export const ADMIN_SEGMENT_API_ROOT = '/admin/segment';

export const ADMIN_SEGMENT_API_PATHS = {
  GET_ALL: `${ADMIN_SEGMENT_API_ROOT}/list`,
};
